import {
  flow,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';
import { DateTime } from './DateTime';
import { modelWithCRUD } from './utils/modelWithCRUD';

const Integration = types.model('IntegrationModel', {
  id: types.union(types.identifier, types.identifierNumber),
  key: types.string,
  activated_at: types.maybeNull(DateTime),
  configuration: types.frozen(),
  integration_type: types.frozen<IIntegrationType>(),
});

export interface IIntegrationType {
  info: {
    key: string;
    version: string;
    name: string;
    description: string;
    icon?: string;
    // client_auth_url is a url for authenticating using simple redirect/oauth in the client.
    // Usecase: e-conomic
    client_auth_url?: string;
  };
  schema: any;
}

export const IntegrationStore = modelWithCRUD('integrations', Integration)
  .named('IntegrationStore')
  .actions((self) => ({
    getAllTypes: flow(function* getAllTypes() {
      const { data } = yield self.env.api.get<IIntegrationType[]>(
        `${self.apiPath}/types/`
      );
      return data;
    }),
    testIntegration: flow(function* testIntegration(integration: IIntegration) {
      const { data } = yield self.env.api.get(
        `${self.apiPath}/${integration.id}/test/`
      );
      return data;
    }),
    activate: flow(function* activate(integration: IIntegration) {
      const { data } = yield self.env.api.post(
        `${self.apiPath}/${integration.id}/activate/`
      );
      self.putItem(data);
      return data;
    }),
    deactivate: flow(function* activate(integration: IIntegration) {
      const { data } = yield self.env.api.post(
        `${self.apiPath}/${integration.id}/deactivate/`
      );
      self.putItem(data);
      return data;
    }),
  }));

export interface IIntegration extends Instance<typeof Integration> {}
export interface IIntegrationSnapshotIn
  extends SnapshotIn<typeof Integration> {}
export interface IIntegrationSnapshotOut
  extends SnapshotOut<typeof Integration> {}
